<template>
<div>
    <Tipificacion @setProducto="set_producto" ref="tipificacion"></Tipificacion>
    <div v-if="!ver">
        <div v-if="(producto == '' && motivo == '' && subMotivo == '')">
            <h4>Elegir Producto:</h4>
            <div class="flex">
                <base-button size="md" type="primary" v-for="productos in allproductos" :key="productos.id" class="mr-2 mb-2" @click="getMotivos(productos)">{{productos.nombre}}</base-button>
            </div>
        </div>
        <div v-if="(producto != '' && motivo == '' && subMotivo == '')">
            <h4>Elegir Motivo:</h4>
            <div class="flex">
                <base-button size="md" type="info" v-for="motivos in allMotivos" :key="motivos.id" class="mr-2 mb-2" @click="getSubMotivos(motivos)">{{motivos.nombre}}</base-button>
            </div>
        </div>
        <div v-if="(producto != '' && motivo != '' && subMotivo == '')">
            <h4>Elegir SubMotivo:</h4>
            <div class="flex">
                <base-button size="md" type="warning" v-for="submotivos in allSubMotivos" :key="submotivos.id" class="mr-2 mb-2" @click="saveSubMotivo(submotivos)">{{submotivos.nombres}}</base-button>
            </div>
        </div>

        <div v-if="(producto != '' && motivo != '' && subMotivo != '' && $refs.tipificacion.idcuenta == null)">
            <h4>Elegir Cuenta:</h4>
            <div class="d-flex" style="height:44px;">
                <select v-model="idcuenta" class="form-control form-control-alternative input-custom">
                    <option v-for="items in allCuentas" :key="items.id" :label="items.razonsocial" :value="items.id"></option>
                </select>
                <base-button size="sm" class="btn-custom" @click="enviarCuenta"><i :class="!idcuenta ? 'fa fa-arrow-right' : 'fa fa-plus'"></i></base-button>
            </div>
        </div>

        <div v-if="(producto != '' && motivo != '' && subMotivo != '' && $refs.tipificacion.idcuenta !== null && $refs.tipificacion.asunto == '')">
            <h4><span class="text-danger">*</span> Agregar Asunto:</h4>
            <div class="d-flex" style="height:44px;">
                <base-input class="w-100" alternative="" input-classes="form-control-alternative input-custom" v-model="asunto"/>
                <base-button size="sm" class="btn-custom" @click="enviarAsunto"><i class="fa fa-plus"></i></base-button>
            </div>
        </div>

        <div v-if="(producto != '' && motivo != '' && subMotivo != '' && $refs.tipificacion.asunto)">
            <h4>Agregar Nota:</h4>
            <textarea class="form-control form-control-alternative" rows="3" placeholder="Mensaje..." v-model="firstMessage"></textarea>
            <!-- <base-button @click="save"></base-button> -->
        </div>
    </div>

    <div v-if="ver">
        <div v-if="(producto != '' && motivo == '' && subMotivo == '')">
            <h4>Elegir Producto:</h4>
            <div class="flex">
                <base-button size="md" type="primary" v-for="productos in allproductos" :key="productos.id" class="mr-2" @click="getMotivos(productos)">{{productos.nombre}}</base-button>
            </div>
        </div>
        <div v-if="(producto != '' && motivo != '' && subMotivo == '')">
            <h4>Elegir Motivo:</h4>
            <div class="flex">
                <base-button size="md" type="info" v-for="motivos in allMotivos" :key="motivos.id" class="mr-2" @click="getSubMotivos(motivos)">{{motivos.nombre}}</base-button>
            </div>
        </div>
        <div v-if="(producto != '' && motivo != '' && subMotivo != '')">
            <h4>Elegir SubMotivo:</h4>
            <div class="flex">
                <base-button size="md" type="warning" v-for="submotivos in allSubMotivos" :key="submotivos.id" class="mr-2" @click="saveSubMotivo(submotivos)">{{submotivos.nombres}}</base-button>
            </div>
        </div>
    </div>
    
   
</div>
</template>

<style>
    .vue-notification {
        margin-top: 15px;
    }

    .input-custom {
        border-radius: 0.375rem 0 0 0.375rem!important;
    }

    .btn-custom {
        border-radius: 0 0.375rem 0.375rem 0!important;

        &:hover {
            -webkit-transform: translateY(0px)!important;
            transform: translateY(0px)!important;
        }
    }
</style>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import Tipificacion from './Tipificacion'
export default {
    data(){
        return{
            ver: false,
            asunto: '',
            idcuenta: null,
            firstMessage: ''
        }
    },
    components:{
        Tipificacion
    },
    computed:{
        ...mapGetters('casos', { allproductos: 'Allproductos', allMotivos: 'Allmotivos', allSubMotivos: 'Allsubmotivos'}),
        ...mapGetters('casos', { producto: 'producto', motivo: 'motivo', subMotivo: 'subMotivo'}),
        ...mapGetters('cuentas', { allCuentas: 'all'}),
        ...mapGetters('notas', { oneNotas: 'one' }),
    },

    methods:{
        ...mapActions('casos',{ Productos: 'getProductos', Motivos: 'getMotivos', SubMotivos: 'getSubMotivos', createCaso: 'createCaso'}),
        ...mapActions('cuentas', { getAllCuentas: 'getAll' }),
        ...mapActions('notas', { saveNotas: 'save' }),

        //seteo de producto, motivo, submotivo
        ...mapMutations('casos',['setProducto','setMotivo','setSubMotivo']),
      
        getMotivos(producto){
            this.ver = false
            //guardo el producto y traigo los motivos
            let data = {
                "idproducto": producto.id
            }
            this.Motivos(data)
            this.setProducto(producto)
    
        },
        getSubMotivos(motivo){
            this.ver = false
            //guardo el motivo y traigo los submotivos
            let data = {
                "idproducto": this.$store.getters['casos/producto'].id,
                "idtipo": motivo.id
            }
            this.SubMotivos(data)
            this.setMotivo(motivo)
        },
        saveSubMotivo(subMotivo){
            this.ver = false
            this.setSubMotivo(subMotivo)
        },
        
        //funcion que vuelve 
        set_producto(value){   
            this.ver = true     
            switch(value){
                case 'producto': 
                    if(this.motivo){
                        this.setMotivo('')
                    }
                    if(this.subMotivo){
                        this.setSubMotivo('')
                    }

                break;
                case 'motivo': 
                    if(this.subMotivo){
                        this.setSubMotivo('')
                    }
                break;
                case 'submotivo':
                break;
            }
        },
        save() {
            if (this.$refs.tipificacion.asunto) {
                let form = {
                    idcontacto: this.$store.getters['auth/contacto'].id,
                    idproducto: this.producto.id,
                    idtipo: this.motivo.id,
                    idsubtipo: this.subMotivo.id,
                    idcuenta: this.$refs.tipificacion.idcuenta == 0 ? null : this.$refs.tipificacion.idcuenta,
                    asunto: this.$refs.tipificacion.asunto
                }
                this.createCaso(form)
                .then((resp) => {
                    if(this.firstMessage.length > 0) {
                        this.oneNotas.texto = this.firstMessage
                        let query = { 
                            idobjeto: resp.id,
                            tipoobjeto: 'casos',
                            texto: this.oneNotas.texto
                        }
                        this.saveNotas(query)
                        .then(() => {
                            this.$notify({
                                group: 'foo',
                                title: 'Mensaje',
                                type: 'success',
                                speed: 1000,
                                duration: 500,
                                text: 'La nota se ha añadido exitosamente.'
                            });
                            this.oneNotas.texto = ''
                        })
                    }
                    this.$notify({
                        group: 'foo',
                        title: 'Mensaje',
                        type: 'success',
                        speed: 1000,
                        duration: 500,
                        text: 'El caso se ha creado exitosamente.'
                    });
                    this.getAll()
                    this.resetearCrearCaso()
                    this.$emit('event')
                }).catch(() => {
                    this.$notify({
                        group: 'foo',
                        title: 'Mensaje',
                        type: 'error',
                        speed: 1000,
                        duration: 500,
                        text: 'Ocurrió un error al intentar realizar la operación.'
                    });
                })
            } else {
                this.$notify({
                    group: 'foo',
                    title: 'Mensaje',
                    type: 'error',
                    speed: 1000,
                    duration: 500,
                    text: 'Faltan campos por completar.'
                });
            }
        },
        getAll(){
            Promise.all([
                this.Productos(),
                this.getAllCuentas()
            ]).then(() => {
            })
        },
        enviarAsunto() {
            if (!this.asunto) {
            } else {
                this.$refs.tipificacion.asunto = this.asunto
            }
        },
        enviarCuenta() {
            if (this.idcuenta == null) {
                this.idcuenta = 0
                this.$refs.tipificacion.idcuenta = this.idcuenta
            } else {
                this.$refs.tipificacion.idcuenta = this.idcuenta
            }
        },
        resetearCrearCaso() {
            this.setProducto('')
            this.setMotivo('')
            this.setSubMotivo('')
            this.$refs.tipificacion.idcuenta = null
            this.idcuenta = null
            this.$refs.tipificacion.asunto = ''
            this.asunto = ''
            this.firstMessage = ''
            this.ver = false
        }
    },
    mounted(){
        this.getAll()
    }
}
</script>
